// Utilisé dans le cadre de la personnalisation de l'espace
export const LOCAL_STORAGE_PERSO_NUMERO_CLIENT = "LOCAL_STORAGE_PERSO_NUMERO_CLIENT"
export const LOCAL_STORAGE_PERSO_CLIENT = "LOCAL_STORAGE_PERSO_CLIENT"

// Usages généraux

// Clés formulaires de creation de demande
export const LOCAL_STORAGE_COMMANDE_CHOIX_DISPOSITIF = "LOCAL_STORAGE_COMMANDE_CHOIX_DISPOSITIF"
export const LOCAL_STORAGE_COMMANDE_INFO_COMPL = "LOCAL_STORAGE_COMMANDE_INFO_COMPL"
export const LOCAL_STORAGE_COMMANDE_ATTRIBUTION = "LOCAL_STORAGE_COMMANDE_ATTRIBUTION"
export const LOCAL_STORAGE_COMMANDE_PRESTATION = "LOCAL_STORAGE_COMMANDE_PRESTATION" // TODO _ supprimer
export const LOCAL_STORAGE_COMMANDE_CHOIX_PRESTATION = "LOCAL_STORAGE_COMMANDE_CHOIX_PRESTATION"
export const LOCAL_STORAGE_COMMANDE_DETAILS_PRESTATION = "LOCAL_STORAGE_COMMANDE_DETAILS_PRESTATION"
export const LOCAL_STORAGE_COMMANDE_INFO_PAIEMENT = "LOCAL_STORAGE_COMMANDE_INFO_PAIEMENT"
export const LOCAL_STORAGE_COMMANDE_CONFIRMATION = "LOCAL_STORAGE_COMMANDE_CONFIRMATION"

export const LOCAL_STORAGE_COMMANDE_KEYS = [
    LOCAL_STORAGE_COMMANDE_CHOIX_DISPOSITIF,
    LOCAL_STORAGE_COMMANDE_INFO_COMPL,
    LOCAL_STORAGE_COMMANDE_ATTRIBUTION,
    LOCAL_STORAGE_COMMANDE_PRESTATION,
    LOCAL_STORAGE_COMMANDE_CHOIX_PRESTATION,
    LOCAL_STORAGE_COMMANDE_DETAILS_PRESTATION,
    LOCAL_STORAGE_COMMANDE_INFO_PAIEMENT,
    LOCAL_STORAGE_COMMANDE_CONFIRMATION,
]

// Clé d'inscription AICI
export const LOCAL_STORAGE_INSCRIPTION_AICI = "LOCAL_STORAGE_INSCRIPTION_AICI"
